import { createStyles, makeStyles } from '@mui/styles';

// Shared styles for the card components (extracted from the former AppCards.js).
export const useCardStyles = makeStyles((theme) =>
  createStyles({
    card: {
    },
    appInfoCard: {
      display: 'flex',
      flexDirection: 'row',
      position: 'relative',
      overflow: 'initial'
    },
    appInfoCardContent: {
      flex: '1 0 auto',
      display: 'flex',
      flexDirection: 'column'
    },
    attentionCard: {
      color: 'white',
    }
  }),
);
